<template>
  <div>
    <div class="meta" v-loading='loading'>
      <el-form label-position="left"
        status-icon
        :hide-required-asterisk="true"
        :model="experimentForm"
        :rules="experimentRule"
        ref="experimentForm"
        label-width="155px"
        class="experimentForm">
        <el-form-item label='唯一编码：' style="width: 650px">
          <span>{{ experimentForm.code }}</span>
        </el-form-item>
        <el-form-item label="实验名称：" prop="name" style="width: 350px">
          <span v-if="!edit">{{ experimentForm.title }}</span>
          <el-input v-else v-model="experimentForm.title"></el-input>
        </el-form-item>
        <el-form-item label="实验类型：" prop="type">
          <span v-if="!edit">{{ experimentForm.type == 1 ? '行为收集' : '调查行为' }}</span>
          <el-select v-else v-model="experimentForm.type" placeholder="请选择实验类型">
            <el-option label="行为收集" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实验摘要 :" prop='description' style="width: 60%">
          <span v-show="!edit">{{ experimentForm.description }}</span>
          <el-input v-show='edit' type='textarea' v-model="experimentForm.description"></el-input>
        </el-form-item>
        <el-form-item label="实验描述：" prop="introduce" class="main-right">
          <span v-show="!edit" id='pay'>{{ experimentForm.introduce }}</span>
          <div v-show='edit' id='editorElem' style="text-align:left;height:300px;"></div>
        </el-form-item>
        <div style="overflow: hidden">
          <el-form-item label="到期日期：" required style="width: 350px;float: left" prop="expireTime">
            <span v-if="!edit">{{ experimentForm.expireTime }}</span>
            <el-date-picker v-else type="date" placeholder="选择日期" v-model="experimentForm.expireTime" style="width: 100%;"></el-date-picker>
          </el-form-item>
        </div>
        <div class="p_time">
          <el-form-item label="任务时间 :" prop="range">
            <span v-show="!edit" style="display: inline-block; margin-top: 12px;">
              <span v-if="!edit && isRange == true">
                <span>数据采集固定天数：</span>
                {{ days }}
                <span> / 天</span>
              </span>
              <span v-if="!edit && isRange == false">
                <span>数据采集时间范围：</span>
                {{ start + '至' + end }}
              </span>
            </span>
            <el-radio-group v-show='edit' v-model="experimentForm.range">
              <div style='margin-bottom: 20px'>
                <el-radio :label="1">
                  <span>数据采集固定天数： </span>
                  <el-input-number v-model="days" controls-position="right" :min="1"></el-input-number>
                  <!-- <el-input placeholder='请输入采集天数' v-model="days" ></el-input> -->
                  <span>  天 </span>
                </el-radio>
              </div>
              <div>
                <el-radio :label="2">
                  <span>数据采集时间范围： </span>
                  <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    range-separator="-"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-radio>
              </div>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item label="设定实验项目 :">
            <div v-show="!edit">
              <div v-show="openClose">开关机：<span>{{ openClose }}</span></div>
              <div v-show="Screen">屏幕：<span>{{ Screen }}</span></div>
              <div v-show="wiFi">WiFi：<span>{{ wiFi }}</span></div>
              <div v-show="blue">蓝牙：<span>{{ blue }}</span></div>
              <div v-show="walk">计步：<span>{{ walk }}</span></div>
              <div v-show="phoneFlow">流量：<span>{{ phoneFlow }}</span></div>
              <div v-show="telephone">通话：<span>{{ telephone }}</span></div>
              <div v-show="app">APP安装/卸载：<span>{{ app }}</span></div>
              <div v-show="appUse">APP使用：<span>{{ appUse }}</span></div>
              <div v-show="localTime">位置：<span v-show="isLocation == true">时间段：{{ collectRange }}</span><span v-show="isLocation == true" style="padding-left: 20px">每{{ collectMinutes }}分钟采集</span>
                <span v-show="isLocation == false">时间点：
                  <span class="dian" v-for="(item,cindex) in collectArr" :key="'col'+ cindex">{{ item }}</span>
                </span>
              </div>
            </div>
            <div v-show='edit'>
              <el-checkbox-group v-model="experimentForm.timeArr">
                <el-row class="check">
                  <el-col :span='2'><el-checkbox name="open" label='开关机' ></el-checkbox></el-col>
                  <el-col :span='22'>
                    <div class="dateBox">
                      <el-time-picker
                        is-range
                        @focus='openFocus'
                        v-model="openTime"
                        value-format="HH:mm:ss"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围">
                      </el-time-picker>
                    </div>
                  </el-col>
                </el-row>
                <el-row class="check">
                  <el-col :span='2'><el-checkbox name="screen" label='屏幕' ></el-checkbox></el-col>
                  <el-col :span='22'>
                    <div class="dateBox">
                      <el-time-picker
                        is-range
                        v-model="screenTime"
                        @focus='screenFocus'
                        value-format="HH:mm:ss"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围">
                      </el-time-picker>
                    </div>
                  </el-col>
                </el-row>
                <el-row class="check">
                  <el-col :span='2'><el-checkbox name="wifi" label='WiFi'></el-checkbox></el-col>
                  <el-col :span='22'>
                    <div class="dateBox">
                      <el-time-picker
                        is-range
                        @focus="wifiFocus"
                        v-model="WiFiTime"
                        value-format="HH:mm:ss"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围">
                      </el-time-picker>
                    </div>
                  </el-col>
                </el-row>
                <el-row class="check">
                  <el-col :span='2'><el-checkbox name="blueTooth" label='蓝牙' ></el-checkbox></el-col>
                  <el-col :span='22'>
                    <div class="dateBox">
                      <el-time-picker
                        is-range
                        @focus="blueToothFocus"
                        v-model="blueToothTime"
                        value-format="HH:mm:ss"
                        range-separator="-"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围">
                      </el-time-picker>
                    </div>
                  </el-col>
                </el-row>

                <div style='margin-bottom: 20px'>
                  <el-row>
                    <el-col :span='2'><el-checkbox v-model='walk' label="计步" name="step"></el-checkbox></el-col>
                    <el-col :span='2'><el-checkbox v-model='phoneFlow' label="流量" name="flow"></el-checkbox></el-col>
                    <el-col :span='2'><el-checkbox v-model='telephone' label="通话" name="call"></el-checkbox></el-col>
                    <el-col :span='3'><el-checkbox v-model='app' label="APP安装/卸载" name="app"></el-checkbox></el-col>
                    <el-col :span='3'><el-checkbox v-model='appUse' label="APP使用" name="APP使用"></el-checkbox></el-col>
                  </el-row>
                </div>

                <el-row>
                <el-col :span='2'  class="position"><el-checkbox name="position" label='位置' @change="checkinlist"></el-checkbox></el-col>
                <el-col :span='22'>
                <el-radio-group v-model="positionTimeStyle" style="width: 100%;margin-top:10px" class="group">
                  <el-row>
                    <el-col :span='24' style="margin-bottom: 15px"><el-radio label="时间段"></el-radio></el-col>
                    <el-col :span='24'>
                      <el-row>
                        <el-col :span='11'>
                          <div class="dateBox">
                            <el-time-picker
                              is-range
                              v-model="positionTime"
                              @focus="timeDuan"
                              value-format="HH:mm:ss"
                              range-separator="-"
                              start-placeholder="开始时间"
                              end-placeholder="结束时间"
                              placeholder="选择时间范围">
                            </el-time-picker>
                          </div>
                        </el-col>
                        <el-col :span='13'>
                          <div class="searchBox">
                            <span class="userName">时间间隔：</span>
                            <template>
                                <el-select v-model="positionCollect" placeholder="请选择">
                                    <el-option
                                    v-for="item in positionCollectList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                    </el-option>
                                </el-select>
                            </template>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row style="margin-top: 20px">
                    <el-col :span='24' style="margin-bottom: 15px;">
                      <el-radio label="时间点"></el-radio>
                      <span style="color:#1986e5">(新增时间点: 请输入0-23之间的整数)</span>
                    </el-col>
                    <el-col :span='24'>
                      <el-row>
                        <el-col :span='24'>
                          <div class="timeDuan">
                            <ul>
                              <li v-for="(item,index) in timeOption" :key="index">
                                <span class="timeCount">{{item}} <i class="el-icon-circle-close"  @click="deleteOptionItem(index)"></i></span>
                              </li>
                            </ul>
                            <el-input v-if="addTime" style="width: 10%;margin-bottom: 20px" size='mini' v-model="addTimeItem" @blur="addTimeOption"></el-input>
                            <span class="addTime" @click="showInput"><i class="el-icon-plus"></i>新增时间点</span>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-radio-group>
              </el-col>
            </el-row>
              </el-checkbox-group>
            </div>
          <span v-show="openProject" class="openCollectType">请选择设定实验的位置方式,并填写采集时间</span>
        </el-form-item>
        <el-form-item>
          <el-button style="width: 100px;height: 36px;vertical-align: baseline;" v-show="!edit" @click="editForm('experimentForm')" type='primary'>编辑</el-button>
          <el-button style="width: 100px;height: 36px;vertical-align: baseline;" v-show="edit" @click="modifyForm('experimentForm')" type='primary'>保存</el-button>
          <el-button v-show="edit == true" style="width: 100px;height: 37px;" type="info" @click="goBack">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import E from 'wangeditor'
export default {
  data () {
    var validatorDesc = (rule, value, callback) => {
      if (this.editorContentHtml == '') {
        callback(new Error('请输入实验描述'));
      } else {
        callback();
      }
    };
    var validatorExpireTime = (rule, value, callback) => {
      if (this.experimentForm.expireTime == '') {
        callback(new Error('请选择到期时间'));
      } else {
        callback()
      }
    };
    return {
      loading: false,
      sortArr: [],
      projectId: '',   // 实验id
      walk: '',
      app: '',
      appUse: '',
      telephone: '',
      phoneFlow: '',
      openTime: '', // 开关机时间范围
      openInput: false, // 开关机是否获取焦点
      screenTime: '', // 屏幕时间范围
      screenInput: false, // 屏幕是否获取焦点
      WiFiTime: '',  // WiFi时间范围
      wifiInput: false, // wifi是否获取焦点
      blueToothTime: '', // 蓝牙时间范围
      blueToothInput: false, // 蓝牙是否获取焦点
      positionTime: '',  // 位置时间范围
      timeInput: '',   //时间段是否获取焦点
      positionCollect: 5, // 采集时间段
      timeOption: [], // 时间节点
      addTimeItem: '', // 增加的时间节点
      addTime: false, // 控制增加时间节点的input框显示和隐藏
      positionTimeStyle: '', // 位置选择采集的方式
      days: null, // 任务采集天数
      dateRange: '', // 任务日期范围
      isRange: false,
      openCollectType: false, // 控制任务采集方式错误提示
      openProject: false, // 控制设定实验的错误提示
      positionCollectList: [{
          value: 5,
          label: "每五分钟"
        }, {
          value: 10,
          label: "每十分钟"
        }, {
          value: 30,
          label: '每半小时'
        }, {
          value: 60,
          label: '每一个小时'
        }, {
          value: 120,
          label: '每两个小时'
        }],
      experimentForm: {
        code: '',
        title: '',
        type: '',
        description: '',
        introduce: '',
        range: '',
        expireTime: '',
        timeArr: [],
      },
      experimentRule: {
        title: [
          { required: true, message: '请输入实验名称', trigger: 'blur' },
        ],
        type: [
          { required: true, message: '请选择实验类型', trigger: 'change' }
        ],
        range: [
          { required: true, message: '请选择任务时间', trigger: 'change' }
        ],
        expireTime: [
          { validator: validatorExpireTime}
        ],
        timeArr: [
          { type: 'array', required: true, message: '请至少设定一个实验项目', trigger: 'change' }
        ],
        description: [
          { required: true, message: '请输入实验摘要', trigger: 'blur' },
        ],
        introduce: [
          { validator: validatorDesc, trigger: 'blur' }
        ]
      },
      editor: null,
      editorContentHtml: '',  // wnageditor编辑器的内容
      editorContentText: '',  // wnageditor编辑器的内容
      edit: false, // 是否开启编辑状态
      isLocation: false,  // 回显位置label
      // 回显 ----
      start: '',
      end: '',
      openClose: '',
      Screen: '',
      wiFi: '',
      blue: '',
      localTime: '',
      collectRange: '',
      collectMinutes: '',
      collectArr: '',
      androidUrl: '',
      iosUrl: ''
    }
  },

  computed: {
    timeArr () {
      return this.experimentForm.timeArr
    }
  },

   watch: {
    // 监听数组的变化，控制时间选择的初始值
    timeArr (newValue, oldValue) {
      if (newValue != undefined) {
        if (newValue[newValue.length-1] == '开关机' && newValue.indexOf('开关机') != -1) {
          this.openTime = "00:00:00-23:59:59"
        } else if (newValue[newValue.length-1] == '屏幕' && newValue.indexOf('屏幕') != -1) {
          this.screenTime = "00:00:00-23:59:59"
        } else if (newValue[newValue.length-1] == 'WiFi' && newValue.indexOf('WiFi') != -1) {
          this.WiFiTime = "00:00:00-23:59:59"
        } else if (newValue[newValue.length-1] == '蓝牙' && newValue.indexOf('蓝牙') != -1) {
          this.blueToothTime = "00:00:00-23:59:59"
        }
        if (newValue.indexOf('开关机') == -1) {
          this.openTime = ''
        } if (newValue.indexOf('屏幕') == -1) {
          this.screenTime = ''
        } if (newValue.indexOf('WiFi') == -1) {
          this.WiFiTime = ''
        } if (newValue.indexOf('蓝牙') == -1) {
          this.blueToothTime = ''
        } if (newValue.indexOf('APP使用') == -1) {
          this.appUse = ''
        }
      }
    },
    positionTimeStyle (newValue, oldValue) {
      console.log(newValue)
      if (newValue == '时间点') {
        this.positionTime = ''
        this.positionCollect = null
      } else if (newValue == '时间段') {
        if(!this.positionTime){
        this.positionTime = '00:00:00-23:59:59'
        }
        if(!this.positionCollect){
        this.positionCollect = 5
        }
        this.timeOption = []
        this.sortArr = []
      }
    }
  },

  created () {
    if (this.$route.query.id) {
      this.projectId = +this.$route.query.id
    } else {
      this.projectId = +this.$store.state.projectId
    }
    this.echoExperiment()
  },

  mounted () {
    var editor = new E("#editorElem");
    this.editor = editor
    this.editor.customConfig.onchange = (html) => {
      this.editorContentHtml = html
      this.editorContentText = editor.txt.text()
    }
    this.editor.customConfig.zIndex = 10
    this.editor.create()
  },

  methods: {
    checkinlist () {
      this.experimentForm.timeArr = this.experimentForm.timeArr
    },
    //获取链接
    goLink () {
      this.httpPostExp('/app/download/v1/getDownloadUrl').then(res => {
        if (res.code == 0) {
          this.iosUrl = res.data.iosUrl
          this.androidUrl = res.data.androidUrl
        }
      })
    },

    goIos () {
      window.open(this.iosUrl)
    },

    goAnd () {
      window.open(this.androidUrl)
    },
    // 实验内容回显
    echoExperiment () {
      this.loading = true
      this.experimentForm.timeArr = []
      this.httpPost('/web/project/v1/searchProjectDetail', {
        id: this.projectId
      }).then(res => {
        if (res.code == 0) {
          let result = res.data
          this.experimentForm.code = result.code
          this.experimentForm.title = result.title
          this.experimentForm.type = result.type + ''
          this.experimentForm.description = result.description
          document.getElementById('pay').innerHTML = result.introduce
          this.editorContentHtml = result.introduce
          this.editor.txt.html(`${result.introduce}`)
          this.experimentForm.expireTime = result.expireTime
          this.experimentForm.range = result.type
          if (result.days) {
            this.isRange = true
            this.days = result.days
            this.experimentForm.range = 1
          } else {
            this.isRange = false
            this.start = result.startTime
            this.end = result.endTime
            this.dateRange = [this.start, this.end]
            this.experimentForm.range = 2
          }
          this.openClose = result.power
          this.openTime = result.power
          if (this.openTime) {
            this.experimentForm.timeArr.push('开关机')
          }
          this.Screen = result.screen
          this.screenTime = result.screen
          if (this.screenTime) {
            this.experimentForm.timeArr.push('屏幕')
          }
          this.wiFi = result.wifi
          this.WiFiTime = result.wifi
          if (this.WiFiTime) {
            this.experimentForm.timeArr.push('WiFi')
          }
          this.blue = result.bluetooth
          this.blueToothTime = result.bluetooth
          if (this.blueToothTime) {
            this.experimentForm.timeArr.push('蓝牙')
          }
          this.app = result.app
          if (this.app) {
            this.experimentForm.timeArr.push('APP安装/卸载')
          }
          this.appUse = result.appUse
          if (this.appUse) {
            this.experimentForm.timeArr.push('APP使用')
          }
          this.walk = result.walk
          if (this.walk) {
            this.experimentForm.timeArr.push('计步')
          }
          this.phoneFlow = result.phoneFlow
          if (this.phoneFlow) {
            this.experimentForm.timeArr.push('流量')
          }
          this.telephone = result.telephone
          if (this.telephone) {
            this.experimentForm.timeArr.push('通话')
          }
          this.localTime = result.location
          if (this.localTime) {
            this.experimentForm.timeArr.push('位置')
          }
          let local = result.location
          if (local) {
            if (local.indexOf('/') != -1) {
              this.positionTimeStyle = '时间段'
              this.isLocation = true
              let index = local.indexOf('/')
              this.collectMinutes = local.slice(index + 1)
              this.collectRange = local.slice(0, local.length-this.collectMinutes.length-1)
              this.positionTime = local.slice(0, local.length-this.collectMinutes.length-1)
              this.positionCollect = +this.collectMinutes
            } else {
              this.positionTimeStyle = '时间点'
              this.isLocation = false
              this.collectArr = local.split(',')
              this.timeOption = local.split(',')
            }
          }
          this.loading = false
        }  else if (res.code == 10001 || res.code == 10002) {
          this.loading = false
            this.$message({
              type: 'error',
              message: res.message
            })
          } else {
            this.loading = false
          this.$message({
            type: 'error',
            message: res.message
          })
        }
      })
    },

    // 修改实验内容
    modifyForm(formName) {
      this.loading = true
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.experimentForm.range == 1) {
            if (this.days == '') {
              this.openCollectType = true
            } else {
              this.openCollectType = false
            }
          } else if (this.experimentForm.range == 2) {
            if (this.dateRange == '') {
              this.openCollectType = true
            } else {
              this.openCollectType = false
            }
          }
          if (this.experimentForm.timeArr.indexOf('位置') != -1) {
            if (this.positionTimeStyle == '时间段') {
              if (this.positionTime == '' || this.positionCollect <= 0) {
              this.openProject = true
              } else {
                this.openProject = false
              }
            } else if (this.positionTimeStyle == '时间点') {
              if (this.timeOption == []) {
              this.openProject = true
              } else {
                this.openProject = false
              }
            }
          }
          if (this.openCollectType == false && this.openProject == false) {
            // 到期时间
            let expTime = this.forTime(this.experimentForm.expireTime) + " " + 23 + ":" + 59 + ":" + 59
            // 任务日期范围
            var time;
            var days;
            if (this.experimentForm.range == 1) {
              days = +this.days;
              this.start = null
              this.end = null
            } else {
              if (this.dateRange && this.experimentForm.range == 2) {
                time = this.dateRange
                days = null
                this.start = this.forTime(this.dateRange[0]) + " " + '00' + ":" + '00' + ":" + '00'
                this.end = this.forTime(this.dateRange[1]) + " " + 23 + ":" + 59 + ":" + 59
              }
            }
            // 开关机
            let index1 = this.experimentForm.timeArr.indexOf('开关机')
            if (this.experimentForm.timeArr.indexOf('开关机') != -1 && this.openTime != '') {
              if (this.openInput) {
                this.openClose = this.formateOpen(this.openTime, true)
              } else {
                this.openClose = this.openTime
              }
              } else if (index1 != -1) {
                this.experimentForm.timeArr.splice(index, 1)
              } else {
              this.openClose = ''
              this.openTime = ''
            }
            // 屏幕
            let index2 = this.experimentForm.timeArr.indexOf('屏幕')
            if (this.experimentForm.timeArr.indexOf('屏幕')  != -1 && this.screenTime != '') {
              if (this.screenInput) {
                this.Screen = this.formateOpen(this.screenTime, true)
              } else {
                this.Screen = this.screenTime
              }
            } else if (index2 != -1) {
              this.experimentForm.timeArr.splice(index, 1)
            } else {
              this.Screen = ''
              this.screenTime = ''
            }
            // wiFi
            let index3 = this.experimentForm.timeArr.indexOf('WiFi')
            if (this.experimentForm.timeArr.indexOf('WiFi') != -1 && this.WiFiTime != '') {
              if (this.wifiInput) {
                this.wiFi = this.formateOpen(this.WiFiTime, true)
              } else {
                this.wiFi = this.WiFiTime
              }
            } else if (index3 != -1) {
              this.experimentForm.timeArr.splice(index, 1)
              } else {
              this.wiFi = ''
              this.WiFiTime = ''
            }
            // 蓝牙
            let index4 = this.experimentForm.timeArr.indexOf('蓝牙')
            if (this.experimentForm.timeArr.indexOf('蓝牙') != -1 && this.blueToothTime != '') {
              if (this.blueToothInput) {
                this.blue = this.formateOpen(this.blueToothTime, true)
              } else {
                this.blue = this.blueToothTime
              }
            } else if (index4 != -1) {
              this.experimentForm.timeArr.splice(index, 1)
            } else {
              this.blue = ''
              this.blueToothTime = ''
            }
            // 位置的时间段
            if (this.experimentForm.timeArr.indexOf('位置') != -1) {
              if (this.positionTimeStyle == '时间段') {
                if (this.timeInput) {
                  this.localTime = this.formateOpen(this.positionTime, true)
                } else {
                  this.localTime = this.positionTime
                }
                this.localTime = this.localTime + "/" + this.positionCollect
              } else if (this.positionTimeStyle == '时间点') {
                this.timeOption = this.timeOption.map(item => {
                  return item
                })
                this.localTime = this.timeOption.join(',')
              }
            } else {
              this.localTime = ''
              this.positionTimeStyle = ''
              this.timeOption = []
              this.positionCollect = 5
            }

            // app 计步 蓝牙 流量
            if (this.experimentForm.timeArr.indexOf('APP安装/卸载') != -1) {
              this.app = '00:00:00-23:59:59'
            }
            if (this.experimentForm.timeArr.indexOf('计步') != -1) {
              this.walk = '00:00:00-23:59:59'
            }
            if (this.experimentForm.timeArr.indexOf('流量') != -1) {
              this.phoneFlow = '00:00:00-23:59:59'
            }
            if (this.experimentForm.timeArr.indexOf('通话') != -1) {
              this.telephone = '00:00:00-23:59:59'
            }
            if (this.experimentForm.timeArr.indexOf('APP使用') != -1) {
              this.appUse = '00:00:00-23:59:59'
            }
            let param = {
              id: this.projectId,
              app: this.app, // app
              appUse: this.appUse,
              walk: this.walk, // 计步
              phoneFlow: this.phoneFlow,  // 流量
              telephone: this.telephone, // 通话
              type: 1,  // 类型
              title: this.experimentForm.title, // 实验名称
              description: this.experimentForm.description,  // 实验摘要
              introduce: this.editorContentHtml, // 实验描述
              expireTime: expTime,
              days: days,  // 数据采集固定天数
              startTime: this.start, // 数据采集开始时间
              endTime: this.end, // 数据采集结束时间
              power: this.openClose,
              wifi: this.wiFi,
              screen: this.Screen,
              bluetooth: this.blue,
              location: this.localTime,
              phoneModel: null,
            }
            this.httpPost('/web/project/v1/updateProjectDetail',param).then((res) => {
              if (res.code == 0) {
                this.loading = false
                this.$message({
                  type: 'success',
                  message: res.message
                })
                this.$router.push('/index')
              } else if (res.code == 10001 || res.code == 10002) {
                this.loading = false
                  this.$message({
                    type: 'error',
                    message: res.message
                  })
                } else {
                this.$message({
                  type: 'error',
                  message: res.message
                })
              }
            })
          }
        } else {
          return false;
        }
      });
    },

    // 当开关机input获取焦点时
    openFocus () {
      if (this.openTime) {
        this.openInput = true
      } else {
        this.openInput = false
      }
    },
    //屏幕获取焦点
    screenFocus () {
      if (this.screenTime) {
        this.screenInput = true
      } else {
        this.screenInput = false
      }
    },
    // wifi获取焦点
    wifiFocus () {
      if (this.WiFiTime) {
        this.wifiInput = true
      } else {
        this.wifiInput = false
      }
    },
    // 蓝牙获取焦点
    blueToothFocus () {
      if (this.blueToothTime) {
        this.blueToothInput = true
      } else {
        this.blueToothInput = false
      }
    },
    // 时间段获取焦点
    timeDuan () {
      this.timeInput = true
    },

    // 格式化开关机，屏幕，wifi，蓝牙
    formateOpen (time,status) {
      let open = time
      var openStr;
      return time[0]+ '-' + time[1]
    },

    // 显示增加时间节点的input输入框
    showInput () {
      this.addTime = true
    },

    // 增加时间节点的input框失焦事件
    addTimeOption () {
      this.timeOption = []
      if (this.addTimeItem < 24 && this.addTimeItem >= 0 && this.addTimeItem != '' ) {
        if (this.sortArr.indexOf(this.addTimeItem) == -1) {
          this.sortArr.push(this.addTimeItem)
          this.sortArr = this.sortArr.sort(function(a, b){return a - b})
        } else {
          this.$message({
          type: 'warning',
          message: '该时间节点已存在'
        })
        }
        this.addTime = false
        this.addTimeItem= ''
      } else {
        this.$message({
          type: 'error',
          message: '请输入0-23之间的整数'
        })
        this.addTimeItem= ''
        this.addTime = false
      }
      this.sortArr.forEach(item => {
        if (this.addTimeItem < 10) {
          this.addTimeItem = '0'+ this.addTimeItem
        }
        this.timeOption.push(item + ':00:00')
      })
      this.addTimeItem = ''
    },
    // 删除时间节点
    deleteOptionItem (index) {
      this.timeOption.splice(index, 1)
      this.sortArr.splice(index, 1)
    },

    // 返回
    goBack () {
      this.edit = false
    },

    // 编辑
    editForm (formName) {
      this.edit = !this.edit
    }
  }
}
</script>

<style scoped>
  .main-right>>>.w-e-text-container {
    height: 260px !important;
    overflow: auto;
  }
  .main-right>>>.surveyBox{
    width: 90%;
    margin-bottom: 50px;
    border: 1px solid #ccc;
    border-top: 0px solid #ccc;
  }
  .main-right>>>.surveyHeader{
    height: 40px;
    line-height: 40px;
    background-color: #eee;
    color: #444;
    padding: 0 20px;
  }
  .main-right>>>.surveyFooter{
    padding: 20px;
    text-align: left;
    line-height: 30px;
  }
  .main-right>>>.exp-download {
    float: right;
    height: 30px;
    width: 70%;
    padding: 10px 0;
    margin: 10px 0px;
    line-height: 6px;
    cursor: pointer;
    text-align: center;
    font-size: 15px;
    border: 2px solid #3c82a8;
    border-radius: 33px;
    color: #fff;
    background-color: #3c82a8;
    text-decoration: none;
  }
  .experimentForm>>>.el-radio-group {
    display: inline-block;
    line-height: 1;
    vertical-align: middle;
    font-size: 0;
    margin-top: 13.5px !important;
  }
  .group>>>.el-radio {
    color: #606266;
    font-weight: 500;
    line-height: 1;
    position: relative;
    cursor: pointer;
    display: inline-block;
    white-space: nowrap;
    outline: none;
    font-size: 14px;
    margin-right: 10px;
    margin-bottom: 10px;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
  .main-right>>>.w-e-text {
    padding: 0 10px;
    overflow-y: auto;
  }
  .meta>>>.el-input-number.is-controls-right .el-input-number__decrease, .el-input-number.is-controls-right .el-input-number__increase {
    height: auto;
    line-height: 20px;
  }
  .p_time>>>.el-form-item__label {
    text-align: left;
    margin-top: 13px;
  }
</style>

<style lang="scss" scoped>
  .set{
    font-weight: 700;
    margin-bottom: 20px;
  }
  .check{
    width: 100%;
    margin-bottom: 20px;
  }
  .openIcon{
    line-height: 40px;
  }
  .addTime{
    display: inline-block;
    width: 100px;
    text-align: center;
    border: 1px solid #1986e5;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
    color: #1986e5;
    i{
      font-weight: 600;
    }
  }
  .timeCount{
    position: relative;
    display: inline-block;
    height: 30px;
    padding-left: 15px;
    line-height: 30px;
    text-align: left;
    border: 1px solid #ccc;
    width: 90%;
    i{
      position: absolute;
      top: 7px;
      right: 10px;
      cursor: pointer;
      color: #1986e5;
      font-size: 15px;
    }
  }
  .timeDuan{
    li{
      width: 12%;
      float: left;
      margin-bottom: 10px;
      margin-right: 10px;
    }
  }
  .openCollectType{
    color: #f56c6c;
    font-size: 12px;
  }
  .dian{
    display: inline-block;
    width: 70px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/data/metaData.vue